import React, { useState } from "react";
import {
  Flex,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  InputGroup,
  Input,
  InputRightElement,
  useDisclosure,
  IconButton,
  Button,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import { CalendarIcon, ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import moment from "moment";

const monthNames = moment.monthsShort();

export const MonthPicker = ({ value, onChange, disabled, disabledDates }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [viewYear, setViewYear] = useState(value ? value.year() : moment().year());

  const selectedMonth = value ? value.month() : null;
  const selectedYear = value ? value.year() : null;

  const handleSelect = (monthIndex) => {
    const newMoment = moment({ year: viewYear, month: monthIndex });
    if (onChange) onChange(newMoment);
    onClose();
  };

  const borderColor = useColorModeValue("gray.300", "whiteAlpha.300");
  const hoverBg = useColorModeValue("gray.100", "whiteAlpha.100");

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom-start">
      <PopoverTrigger>
        <InputGroup
          width="220px"
          onClick={!disabled ? onOpen : undefined}
          cursor={disabled ? "not-allowed" : "pointer"}
        >
          <Input
            readOnly
            value={value ? value.format("MMM YYYY") : ""}
            placeholder="Select month"
            borderColor={borderColor}
            _hover={!disabled ? { borderColor: "blue.400" } : {}}
            _focus={{ borderColor: "var(--brand-primary)", boxShadow: "0 0 0 1px var(--brand-primary)" }}
            isDisabled={disabled}
          />
          <InputRightElement pointerEvents="none">
            <CalendarIcon color="gray.500" />
          </InputRightElement>
        </InputGroup>
      </PopoverTrigger>

      <PopoverContent
        w="260px"
        borderRadius="md"
        shadow="md"
        _focus={{ boxShadow: "outline" }}
      >
        <PopoverBody>
          <Flex align="center" justify="space-between" mb={3}>
            <IconButton
              aria-label="Previous year"
              icon={<ChevronLeftIcon />}
              size="sm"
              variant="ghost"
              onClick={() => setViewYear(viewYear - 1)}
            />
            <Text fontWeight="semibold">{viewYear}</Text>
            <IconButton
              aria-label="Next year"
              icon={<ChevronRightIcon />}
              size="sm"
              variant="ghost"
              onClick={() => setViewYear(viewYear + 1)}
            />
          </Flex>

          <Grid templateColumns="repeat(3, 1fr)" gap={2}>
            {monthNames.map((month, idx) => {
              const currentMoment = moment({ year: viewYear, month: idx });
              const isSelected =
                selectedYear === viewYear && selectedMonth === idx;

              const isDisabled = disabledDates
                ? disabledDates(currentMoment)
                : false;

              return (
                <Button
                  key={month}
                  size="sm"
                  variant={isSelected ? "solid" : "outline"}
                  bg={isSelected ? "var(--brand-primary)" : "white"}
                  color={isSelected ? "white" : isDisabled ? "gray.400" : "black"}
                  borderColor={isSelected ? "blue.500" : borderColor}
                  _hover={!isDisabled ? { bg: hoverBg } : {}}
                  onClick={() => !isDisabled && handleSelect(idx)}
                  isDisabled={isDisabled}
                >
                  {month}
                </Button>
              );
            })}
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
